export default __webpack_public_path__ + "static/qa_service_features-2364f96dfabb3ea64a984c6d5fe2bea6.svg";